import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { connect } from "react-redux";

import { formattedBranchName } from "../../helpers/formatter";

const HeroSliderTenSingle = ({ data, sliderClass }) => {
  const curr_location = useSelector((state) => state.locationsData.location);
  return (
    <div
      className={`single-slider-2 slider-height-2 d-flex align-items-center bg-img ${
        sliderClass ? sliderClass : ""
      }`}
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL + data.image})` }}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-7 col-md-8 col-12 ml-auto">
            <div
              className="slider-content-3 slider-animated-1 text-center  p-20"
              style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
            >
              <h3 className="animated">{data.title}</h3>
              <h1 className="animated">{data.subtitle}</h1>
              <p className="animated">{data.text}</p>
              <div className="slider-btn btn-hover">
                {data.url !== "" && (
                  <a
                    className="animated"
                    href={
                      !data.external
                        ? process.env.PUBLIC_URL +
                          `/${formattedBranchName(curr_location.name)}${
                            data.url
                          }`
                        : `${data.url}`
                    }
                  >
                    REGISTER NOW
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

HeroSliderTenSingle.propTypes = {
  data: PropTypes.object,
  sliderClass: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    cLocation: state.locationsData.location,
  };
};

export default connect(mapStateToProps)(HeroSliderTenSingle);
